import LoadingButton from "@mui/lab/LoadingButton";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

export default function ConfirmationDialog(props) {
    const { t } = useTranslation();

    return (
        <Dialog fullWidth open={props.open} maxWidth={props.maxWidth}>
            <DialogTitle
                sx={props.titleSx}
                align={props.titleAlign}
                className="capitalize-first-letter"
            >
                {props.title}
            </DialogTitle>
            {props.showCloseButton && (
            <IconButton
                aria-label="close"
                onClick={props.onCancel}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 16,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            )}
            {props.content !== undefined && (
                <DialogContent
                    dividers={props.showDialogContentDividers}
                    align={props.contentTextAlign}
                    sx={props.contentSx}
                >
                    {props.content}
                </DialogContent>
            )}
            <DialogActions sx={{ justifyContent: "center" }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={3}
                >
                    <Grid item xs={props.showCancelButton ? 4 : 6} textAlign={"right"}>
                        <LoadingButton
                            style={{ minWidth: "100px" }}
                            variant="contained"
                            size="small"
                            onClick={props.onYes}
                            color={props.btnYesColor}
                            loading={props.loading}
                        >
                            {t("true")}
                        </LoadingButton>
                    </Grid>
                    <Grid item xs={props.showCancelButton ? 4 : 6} textAlign={props.showCancelButton ? "center" : "left"}>
                        <Button
                            color={props.btnNoColor}
                            style={{ minWidth: "100px" }}
                            variant="contained"
                            size="small"
                            onClick={props.onNo}
                            disabled={props.loading}
                        >
                            {t("false")}
                        </Button>
                    </Grid>
                    {props.showCancelButton && <Grid item xs={4} textAlign={"left"}> 
                        <Button
                            color={props.btnCancelColor}
                            style={{ minWidth: "100px" }}
                            variant="contained"
                            size="small"
                            onClick={props.onCancel}
                            disabled={props.loading}
                        >
                            {t("cancel")}
                        </Button>
                    </Grid>}
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

ConfirmationDialog.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string,
    content: PropTypes.any,
    titleAlign: PropTypes.oneOf(["right", "left", "center"]),
    onYes: PropTypes.func,
    onNo: PropTypes.func,
    showDialogContentDividers: PropTypes.bool,
    contentTextAlign: PropTypes.oneOf(["right", "left", "center"]),
    maxWidth: PropTypes.string,
    titleSx: PropTypes.object,
    contentSx: PropTypes.object,
    btnYesColor: PropTypes.string,
    btnNoColor: PropTypes.string,
    btnCancelColor: PropTypes.string,
    loading: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    showCancelButton: PropTypes.bool,
    onCancel: PropTypes.func
};

ConfirmationDialog.defaultProps = {
    open: false,
    titleAlign: "center",
    maxWidth: "xs",
    showDialogContentDividers: true,
    contentTextAlign: "left",
    btnYesColor: "success",
    btnNoColor: "error",
    btnCancelColor: "primary",
    loading: false,
    showCloseButton: false,
    onCancel: ()=>{}
};
